import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconStage: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"stage, show"} maskId="square-filled-radius-0-stroke-1-IconStage"><path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V20H2V4ZM20.7929 19L17.7929 16H6.20711L3.20711 19H20.7929Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconStage;
